import {Component, OnInit, ViewChild} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import Swal from "sweetalert2";
import {MatSort} from "@angular/material/sort";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {AlmacenService} from "../../services/api/almacen.service";
import {MatTableDataSource} from "@angular/material/table";
import {DialogInventarioMenajeriaComponent} from "./dialog-inventario-menajeria/dialog-inventario-menajeria.component";

@Component({
  selector: 'app-inventario',
  templateUrl: './inventario.component.html',
  styleUrls: ['./inventario.component.css']
})
export class InventarioComponent implements OnInit {

  menajeria:any=[];
  m:any

  displayedColumns: string[] = [
    // 'id',
    'nombre',
    'marca',
    'modelo',
    'cantidad',
    'proveedor',
    'ruc',
    'numFactura',
    'modificar',
   // 'eliminar'
  ];

  dataSource:any;
  loading:boolean=true;


  // @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
  //   this.dataSource.paginator = value;
  // }

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(public dialog:MatDialog,private almacenService:AlmacenService) { }

  ngOnInit(){
    this.dataSource=new MatTableDataSource();
    this.getAllMenajeria();
  }

  getAllMenajeria(){
    this.almacenService.getAllMenajeria().subscribe((response)=>{
      this.menajeria=response.getAllMenajeria;
      this.dataSource.data = this.menajeria;
      this.dataSource.paginator = this.paginator
      this.loading=false;
      return response;
    });

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openDialogModify(i:any): void {

    console.log(i)
    let dialogConfig=new MatDialogConfig();
    this.almacenService.getMenajeria(i).subscribe(response=>{
      this.m=response.getMenajeria;

      dialogConfig.data={
        id:this.m.id,
        nombre:this.m.nombre,
        marca:this.m.marca,
        modelo:this.m.modelo,
        cantidad:this.m.cantidad,
        razonSocial:this.m.factura?.razonSocial,
        ruc:this.m.factura?.ruc,
        numFactura:this.m.factura?.numFactura,
        title:"Modificar Artículo",
        estado:1
      };
      dialogConfig.width="40rem";
      dialogConfig.height="500px";

      let dialogRef = this.dialog.open(DialogInventarioMenajeriaComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
        if(result==1){
          this.getAllMenajeria()
        }
      });

    })


  }
  openDialogAdd(): void {

    let dialogConfig=new MatDialogConfig();
    dialogConfig.data={
      nombre:"",
      marca:"",
      modelo:"",
      cantidad:"",
      razonSocial:"",
      ruc:"",
      numFactura:"",
      title:"Agregar Menajeria",
      estado:2
    };
    dialogConfig.width="40rem";
    dialogConfig.height="500px";

    let dialogRef = this.dialog.open(DialogInventarioMenajeriaComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
        if(result==1){
          this.getAllMenajeria()
        }
    });
  }


  // deleteArticulo(i:number): void {
  //
  //   Swal.fire({
  //     title: 'Estás seguro de que quieres borrar este registro?',
  //     showCancelButton: true,
  //     confirmButtonText: 'Sí',
  //     cancelButtonText: 'No',
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       Swal.fire(
  //         'Eliminado',
  //         'El registro se eliminó satisfactoriamente.',
  //         'success'
  //       )
  //       this.dataSource.data.splice(i, 1);
  //       this.dataSource._updateChangeSubscription();
  //     }
  //     else if (result.dismiss === Swal.DismissReason.cancel) {
  //       console.log("false");
  //     }
  //   })
  //
  //
  // }

}
